import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DropdownState } from '../dropdown/dropdown.component';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
})
export class SelectComponent {

  @Input() value: string | number;
  @Input() options: {
    value: string | number;
    name: string;
  }[];

  @Output() onChange = new EventEmitter<string | number>();

  state: DropdownState = {
    visible: false,
    atTheBottom: false,
  };

  get current() {
    return this.options.find(option => option.value == this.value).name;
  }

  select(option) {
    this.onChange.emit(option);
    this.value = option;
    this.state.visible = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/select/select.component.ts